export const cooperationMode = [
    {
        type: '00',
        text: '股权投资'
    },
    {
        type: '01',
        text: '技术转让'
    },
    {
        type: '02',
        text: '许可使用'
    },
    {
        type: '03',
        text: '合作开发'
    },
    {
        type: '04',
        text: '合作兴办新企业'
    },
    {
        type: '05',
        text: '其他 '
    },
    {
        text: ' 技术咨询',
        type: '06'
    },
    {
        text: '技术服务',
        type: '07'
    }
]

export const cooperationModeNew = [
    {
        text: '技术转让',
        type: '01'
    },
    {
        text: '作价入股',
        type: '00'
    },
    {
        text: '合作开发',
        type: '03'
    },
    {
        text: '技术许可',
        type: '02'
    },
    {
        text: '其他',
        type: '05'
    }
]

// 合作方式
export const cooperationWay = [
    {
        text: '技术转让',
        type: '01'
    },
    {
        text: '许可使用',
        type: '02'
    },
    {
        text: '合作开发',
        type: '03'
    },
    {
        text: '技术咨询',
        type: '06'
    },
    {
        text: '技术服务',
        type: '07'
    },
    {
        text: '股权投资',
        type: '00'
    },
    {
        text: '合作兴办新企业',
        type: '04'
    },
    {
        text: '其他',
        type: '05'
    }
]

export const kfPayMode = [
    {
        type: '00',
        text: '免费'
    },
    {
        type: '01',
        text: '入门费和提成费相结合'
    },
    {
        type: '02',
        text: '一次总付'
    },
    {
        type: '03',
        text: '总付额内分期付款'
    },
    {
        type: '04',
        text: '其他明确合理的使用费标准'
    }
]
